import { SortAscendingOutlined, SortDescendingOutlined } from '@ant-design/icons';
import styles from './SortableColumnTitle.module.scss';

interface SortableColumnTitleProps {
  label: string;
  field: string;
  activeField: string;
  sortOrder: 'asc' | 'desc';
  onSort: (field: string) => void;
}

export function SortableColumnTitle({
  label,
  field,
  activeField,
  sortOrder,
  onSort,
}: SortableColumnTitleProps) {
  const isActive = activeField === field;
  const isDesc = isActive && sortOrder === 'desc';
  const ariaSort = isActive ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none';
  const SortIcon = isDesc ? SortDescendingOutlined : SortAscendingOutlined;

  return (
    <button
      type="button"
      className={`${styles.root} ${isActive ? styles.rootActive : ''}`}
      aria-sort={ariaSort}
      onClick={(event) => {
        event.stopPropagation();
        onSort(field);
      }}
    >
      <span className={styles.label}>{label}</span>
      <span className={`${styles.sorter} ${isActive ? styles.sorterActive : ''}`} aria-hidden>
        <SortIcon className={styles.sortIcon} />
      </span>
    </button>
  );
}
